import axios from "axios";

export function fetchBusinessAction(bid) {
    return {
        type: 'FETCH_BUSINESS',
        meta: {
            bid: bid
        },
        payload: async () => {
            const business_resp = await axios.get('/api/v2a/getBusiness', {params: {bid}});

            return business_resp.data;
        }
    };
}

export function editBusinessAction(business) {
    return {
        type: "EDIT_BUSINESS",
        meta: business,
        payload: axios.post('/api/v2a/saveBusiness', business)
    };
}

export function editDefaultSlaAction(bid, sla) {
    return {
        type: "EDIT_DEFAULT_SLA",
        meta: {bid, sla},
        payload: axios.put('/api/v2a/editDefaultSla', {bid, sla})
    };
}